// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"e1a56e43","842":"2b267420","963":"e1370189"}[chunkId] + ".chunk.js";
};